import { contactStrings } from '@data/contacts';
import { newEmailField, requiredStringField } from '@utils/forms';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const friendStatus = t.union([t.literal('AWAIT_CONFIRMATION'), t.literal('CONFIRMED')]);
export type FriendStatus = t.TypeOf<typeof friendStatus>;

export const friend = t.type({
  user: h.omittable(t.number),
  email: t.string,
  status: friendStatus,
  updated_at: t.string,
  created_at: t.string,
});

export type Friend = t.TypeOf<typeof friend>;

export const friendContact = t.type({
  user: t.number,
  email: t.string,
  zip_code: t.string,
  address1: t.string,
  address2: h.omittable(t.string),
  company_name: t.string,
  english_name: t.string,
  display_name: t.string,
});

export type FriendContact = t.TypeOf<typeof friendContact>;

export const friendQueryCode = t.union([
  t.literal(0),
  t.literal(1),
  t.literal(2),
  t.literal(3),
  t.literal(4),
  t.literal(5),
  t.literal(6),
  t.literal(7),
  t.literal(8),
  t.literal(9),
]);

export type FriendQueryCode = t.TypeOf<typeof friendQueryCode>;

export const friendQueryError = t.type({
  email: h.omittable(t.array(t.string)),
});

export type FriendQueryError = t.TypeOf<typeof friendQueryError>;

export const friendQueryResponse = t.type({
  code: friendQueryCode,
  data: h.omittable(friendContact),
});

export type FriendQueryResponse = t.TypeOf<typeof friendQueryResponse>;

export const friendSearchForm = t.type({
  company_name: requiredStringField(contactStrings.company_name),
  email: newEmailField(contactStrings.email),
});

export type FriendSearchForm = t.TypeOf<typeof friendSearchForm>;

export const friendQueryParam = t.type({
  type: t.string,
  company_name: t.string,
  email: t.string,
});

export type FriendQueryParam = t.TypeOf<typeof friendQueryParam>;

export const friendInviteForm = t.type({
  email: requiredStringField(contactStrings.email),
});

export const friendInvitation = t.type({
  id: t.number,
  status: friendStatus,
  email: t.string,
  company: h.omittable(friendContact),
  updated_at: t.string,
  created_at: t.string,
});

export type FriendInvitation = t.TypeOf<typeof friendInvitation>;

export const friendInvitationsQueryParam = t.partial({
  contact_type: t.string,
});

export type FriendInvitationsQueryParam = t.TypeOf<typeof friendInvitationsQueryParam>;

export const patchFriendInvitation = t.type({
  status: friendStatus,
});

export type PatchFriendInvitation = t.TypeOf<typeof patchFriendInvitation>;

export const postFriendInvitation = t.type({
  email: t.string,
  status: friendStatus,
});

export type PostFriendInvitation = t.TypeOf<typeof postFriendInvitation>;
